export default __webpack_public_path__ + "static/media/img6.944f5d85.jpg";